export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth',
  },
  {
    action: 'whiter',
    subject: 'Auth',
  },
  // ADMINISTRATIVO
  {
    action: 'ROLE_ADM_ATUALIZAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_ADM_CONSULTAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_ADM_DELETAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_ADM_INSERIR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_ADMIM_ATUALIZAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_ADMIM_CONSULTAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_ADMIM_DELETAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_ADMIM_INSERIR',
    subject: 'ACL',
  },
  { action: 'ROLE_ASSOCIADO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_ASSOCIADO_INSERIR', subject: 'ACL' },
  { action: 'ROLE_ASSOCIADO_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_ASSOCIADO_DELETAR', subject: 'ACL' },
  { action: 'ROLE_DEPENDENTE_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_DEPENDENTE_INSERIR', subject: 'ACL' },
  { action: 'ROLE_DEPENDENTE_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_DEPENDENTE_DELETAR', subject: 'ACL' },
  { action: 'ROLE_AGREGADO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_AGREGADO_INSERIR', subject: 'ACL' },
  { action: 'ROLE_AGREGADO_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_AGREGADO_DELETAR', subject: 'ACL' },
  { action: 'ROLE_FUNCIONARIO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_FUNCIONARIO_INSERIR', subject: 'ACL' },
  { action: 'ROLE_FUNCIONARIO_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_FUNCIONARIO_DELETAR', subject: 'ACL' },
  { action: 'ROLE_OUTRO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_OUTRO_INSERIR', subject: 'ACL' },
  { action: 'ROLE_OUTRO_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_OUTRO_DELETAR', subject: 'ACL' },
  { action: 'ROLE_FORNECEDOR_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_FORNECEDOR_INSERIR', subject: 'ACL' },
  { action: 'ROLE_FORNECEDOR_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_FORNECEDOR_DELETAR', subject: 'ACL' },
  // COMPONENTES DE CADASTRO
  { action: 'ROLE_DOCUMENTO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_DOCUMENTO_INSERIR', subject: 'ACL' },
  { action: 'ROLE_DOCUMENTO_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_DOCUMENTO_DELETAR', subject: 'ACL' },
  { action: 'ROLE_PROTOCOLO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_PROTOCOLO_INSERIR', subject: 'ACL' },
  { action: 'ROLE_PROTOCOLO_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_PROTOCOLO_DELETAR', subject: 'ACL' },
  { action: 'ROLE_ENDERECO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_ENDERECO_INSERIR', subject: 'ACL' },
  { action: 'ROLE_ENDERECO_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_ENDERECO_DELETAR', subject: 'ACL' },
  { action: 'ROLE_FONE_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_FONE_INSERIR', subject: 'ACL' },
  { action: 'ROLE_FONE_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_FONE_DELETAR', subject: 'ACL' },
  // COMBOS E TABELAS APOIO
  { action: 'ROLE_SEXO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_ESTADO_CIVIL_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_PROFISSAO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_NATURALIDADE_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_NACIONALIDADE_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_TIPO_REGISTRO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_UF_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_PREVIDENCIA_SOCIAL_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_TIPO_ENDERECO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_SITUACAO_REGISTRO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_FAIXA_CONTRIBUICAO_CONSULTAR', subject: 'ACL' },
  // ATENDIMENTO
  {
    action: 'ROLE_ATEND_ATUALIZAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_ATEND_CONSULTAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_ATEND_DELETAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_ATEND_INSERIR',
    subject: 'ACL',
  },
  // ATENDIMENTO DETALHADO
  { action: 'ROLE_CONVENIO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_CONVENIO_INSERIR', subject: 'ACL' },
  { action: 'ROLE_CONVENIO_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_CONVENIO_DELETAR', subject: 'ACL' },
  { action: 'ROLE_CONSELHO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_CONSELHO_INSERIR', subject: 'ACL' },
  { action: 'ROLE_CONSELHO_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_CONSELHO_DELETAR', subject: 'ACL' },
  { action: 'ROLE_DOENCA_CID_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_DOENCA_CID_INSERIR', subject: 'ACL' },
  { action: 'ROLE_DOENCA_CID_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_DOENCA_CID_DELETAR', subject: 'ACL' },
  { action: 'ROLE_ESPECIALIDADE_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_ESPECIALIDADE_INSERIR', subject: 'ACL' },
  { action: 'ROLE_ESPECIALIDADE_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_ESPECIALIDADE_DELETAR', subject: 'ACL' },
  { action: 'ROLE_EXAME_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_EXAME_INSERIR', subject: 'ACL' },
  { action: 'ROLE_EXAME_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_EXAME_DELETAR', subject: 'ACL' },
  { action: 'ROLE_FERIADO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_FERIADO_INSERIR', subject: 'ACL' },
  { action: 'ROLE_FERIADO_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_FERIADO_DELETAR', subject: 'ACL' },
  { action: 'ROLE_GRUPO_PROCEDIMENTO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_GRUPO_PROCEDIMENTO_INSERIR', subject: 'ACL' },
  { action: 'ROLE_GRUPO_PROCEDIMENTO_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_GRUPO_PROCEDIMENTO_DELETAR', subject: 'ACL' },
  { action: 'ROLE_PROCEDIMENTO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_PROCEDIMENTO_INSERIR', subject: 'ACL' },
  { action: 'ROLE_PROCEDIMENTO_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_PROCEDIMENTO_DELETAR', subject: 'ACL' },
  { action: 'ROLE_PROFISSIONAL_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_PROFISSIONAL_INSERIR', subject: 'ACL' },
  { action: 'ROLE_PROFISSIONAL_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_PROFISSIONAL_DELETAR', subject: 'ACL' },
  { action: 'ROLE_SITUACAO_ATENDIMENTO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_SITUACAO_ATENDIMENTO_INSERIR', subject: 'ACL' },
  { action: 'ROLE_SITUACAO_ATENDIMENTO_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_SITUACAO_ATENDIMENTO_DELETAR', subject: 'ACL' },
  { action: 'ROLE_ODONTOGRAMA_STATUS_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_ODONTOGRAMA_STATUS_INSERIR', subject: 'ACL' },
  { action: 'ROLE_ODONTOGRAMA_STATUS_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_ODONTOGRAMA_STATUS_DELETAR', subject: 'ACL' },
  { action: 'ROLE_TIPO_ATENDIMENTO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_TIPO_ATENDIMENTO_INSERIR', subject: 'ACL' },
  { action: 'ROLE_TIPO_ATENDIMENTO_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_TIPO_ATENDIMENTO_DELETAR', subject: 'ACL' },
  { action: 'ROLE_UNIDADE_ATENDIMENTO_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_UNIDADE_ATENDIMENTO_INSERIR', subject: 'ACL' },
  { action: 'ROLE_UNIDADE_ATENDIMENTO_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_UNIDADE_ATENDIMENTO_DELETAR', subject: 'ACL' },
  { action: 'ROLE_PARAMETRO_ATEND_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_PARAMETRO_ATEND_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_CAMPO_ADICIONAL_CONSULTAR', subject: 'ACL' },
  { action: 'ROLE_CAMPO_ADICIONAL_INSERIR', subject: 'ACL' },
  { action: 'ROLE_CAMPO_ADICIONAL_ATUALIZAR', subject: 'ACL' },
  { action: 'ROLE_CAMPO_ADICIONAL_DELETAR', subject: 'ACL' },
  // FINANCEIRO
  {
    action: 'ROLE_FINAN_ATUALIZAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_FINAN_CONSULTAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_FINAN_DELETAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_FINAN_INSERIR',
    subject: 'ACL',
  },
  // USUARIOS
  {
    action: 'ROLE_USER_ATUALIZAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_USER_CONSULTAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_USER_DELETAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_USER_INSERIR',
    subject: 'ACL',
  },
  // CORE
  {
    subject: 'ACL',
    action: 'ROLE_CORE_ATUALIZAR',
  },
  {
    subject: 'ACL',
    action: 'ROLE_CORE_CONSULTAR',
  },
  {
    subject: 'ACL',
    action: 'ROLE_CORE_DELETAR',
  },
  {
    subject: 'ACL',
    action: 'ROLE_CORE_INSERIR',
  },
  // DOWNLOAD
  {
    subject: 'ACL',
    action: 'ROLE_DOWNLOAD',
  },
  // NEOS
  {
    subject: 'ACL',
    action: 'ROLE_NEOS',
  },
  // PERFIL
  {
    subject: 'ACL',
    action: 'ROLE_PERFIL_ATUALIZAR',
  },
  {
    subject: 'ACL',
    action: 'ROLE_PERFIL_CONSULTAR',
  },
  {
    subject: 'ACL',
    action: 'ROLE_PERFIL_DELETAR',
  },
  {
    subject: 'ACL',
    action: 'ROLE_PERFIL_INSERIR',
  },
  // PROFISSIONAL
  {
    subject: 'ACL',
    action: 'ROLE_PROFISSIONAL',
  },
  // RELATORIO
  {
    subject: 'ACL',
    action: 'ROLE_RELATORIO_CONSULTAR',
  },
  // EVENTO
  {
    action: 'ROLE_EVENTO_ATUALIZAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_EVENTO_CONSULTAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_EVENTO_DELETAR',
    subject: 'ACL',
  },
  {
    action: 'ROLE_EVENTO_INSERIR',
    subject: 'ACL',
  },
]

export const _ = undefined
